/**
 * Numbered section heading from prototype `.req-modal-section-h`.
 */
function RequestSection({ number, title, children }) {
  return (
    <section className="border-b border-edge py-3.5 last:border-b-0 last:pb-1.5">
      <div className="mb-2.5 flex items-center gap-2">
        <span
          aria-hidden="true"
          className="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full border border-sky-400/30 bg-sky-400/10 text-[11px] font-bold tabular-nums text-[#7ed3f7] dark:border-[rgba(126,211,247,0.28)] dark:bg-[rgba(126,211,247,0.10)] dark:text-[#7ed3f7]"
        >
          {number}
        </span>
        <h3 className="text-[12.5px] font-bold tracking-[0.005em] text-content">{title}</h3>
      </div>
      {children}
    </section>
  );
}

export default RequestSection;
